"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageChartTooltip = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var utils_1 = require("./utils");
var UsageChartTooltip = function (_a) {
    var _b = _a.data, current = _b.current, comparison = _b.comparison, fuel = _a.fuel, unit = _a.unit, datePeriod = _a.datePeriod, formatter = _a.formatter, comparisonType = _a.comparisonType, rest = __rest(_a, ["data", "fuel", "unit", "datePeriod", "formatter", "comparisonType"]);
    var DataTable = (0, core_1.useComponents)().DataTable;
    var unitProp = unit === 'kwh' ? 'consumption' : 'cost';
    var headings = comparison && comparisonType
        ? [
            'Fuel',
            comparison.date
                ? (0, utils_1.formatComparisonLabel)(comparison.date, datePeriod, comparisonType)
                : undefined,
            current.date
                ? (0, utils_1.formatComparisonLabel)(current.date, datePeriod, comparisonType)
                : undefined,
        ].filter(Boolean) // Remove undefined cells.
        : ['Fuel', current.date && (0, utils_1.formatLabel)(current.date, datePeriod, true)];
    var items = [];
    if (comparison && comparisonType) {
        if (fuel === 'electricity' || fuel === 'both') {
            items.push([
                'Electricity',
                comparison.date
                    ? formatter(comparison.electricity
                        ? comparison.electricity[unitProp]
                        : null)
                    : undefined,
                current.date
                    ? formatter(current.electricity ? current.electricity[unitProp] : null)
                    : undefined,
            ].filter(Boolean));
        }
        if (fuel === 'gas' || fuel === 'both') {
            items.push([
                'Gas',
                comparison.date
                    ? formatter(comparison.gas ? comparison.gas[unitProp] : null)
                    : undefined,
                current.date
                    ? formatter(current.gas ? current.gas[unitProp] : null)
                    : undefined,
            ].filter(Boolean));
        }
    }
    else {
        if ((fuel === 'electricity' || fuel === 'both') && current.electricity) {
            items.push(['Electricity', formatter(current.electricity[unitProp])]);
        }
        if ((fuel === 'gas' || fuel === 'both') && current.gas) {
            items.push(['Gas', formatter(current.gas[unitProp])]);
        }
    }
    return (react_1.default.createElement("div", __assign({}, rest),
        react_1.default.createElement(DataTable, { columnHeadings: headings, items: items })));
};
exports.UsageChartTooltip = UsageChartTooltip;
